import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { ClientListItem } from "@app/client/client";
import { ClientService } from "@app/client/clientService";

export interface CompetitiveInsightsManageAddModalClientsResult {
  clients: ClientListItem[];
  isLoading: boolean;
}

export const COMPETITIVE_INSIGHTS_MANAGE_ADD_MODAL_CLIENTS_QUERY_KEY_PREFIX = "competitive-insights-manage-add-modal-clients";

export const useCompetitiveInsightsManageAddModalClients = (enabled: boolean): CompetitiveInsightsManageAddModalClientsResult => {
  const clientService = useMemo(() => new ClientService(), []);

  const queryResult = useQuery<ClientListItem[]>({
    enabled,
    queryFn: ({ signal }) => clientService.getActiveClientsList(signal),
    queryKey: [COMPETITIVE_INSIGHTS_MANAGE_ADD_MODAL_CLIENTS_QUERY_KEY_PREFIX],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    clients: queryResult.data ?? [],
    isLoading: queryResult.isFetching,
  };
}

export default useCompetitiveInsightsManageAddModalClients;
